import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueI18n from 'vue-i18n'
// import messages from './i18n/langs'
import i18n from './i18n/langs'
import fullModal from './assets/js/fullModal'
import bus from '@/utils/bus'
import './permission'
import VueQuillEditor from 'vue-quill-editor'
import VueVideoPlayer from 'vue-video-player'
import { isMobile,deepClone } from '@/utils/tools.js'
import preventReClick from '@/utils/preventReClick' //防止多次點擊，重複提交
// import { clearRequest } from './utils/request.js'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

// require videojs style
import 'video.js/dist/video-js.css'

// mobile ui
// import Vant from 'vant';
// import 'vant/lib/index.css';

// pc ui
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './assets/css/fullModal.css'
import { Locale } from 'vant';
import zhTW from 'vant/es/locale/lang/zh-TW';
Locale.use('zh-TW', zhTW);

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import axios from 'axios';
Vue.prototype.$axios = axios;


Vue.config.productionTip = false

// Vue.use(VueI18n)

Vue.use(Antd); // pc ui
// Vue.use(VCharts)
Vue.use(VueQuillEditor)

// const i18n = new VueI18n({
//   locale: 'zh-cn', // set locale
//   // locale: 'en-us', // set locale
// locale: 'zh-tw', // set locale
//   messages, // set locale messages
// })

Vue.use(Viewer)
// Viewer.setDefaults({
//   Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
// })
Vue.use(VueVideoPlayer, /* {
  options: global default options,
  events: global videojs events
} */)

Vue.prototype.$fullModal = fullModal
Vue.prototype.$bus = bus
Vue.prototype.$isMobile = isMobile
Vue.prototype.$deepClone = deepClone

const KVue = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

Vue.extend(
  {
    template: '',
    data() { return i18n }
  })

export default KVue;